import HttpHelper from './helper';

export const seasonsEndpoints = {
  getSeasons: (params, signal) => HttpHelper.baseAxios
    .get('/seasons', { params, signal })
    .then((res) => res?.data)
    .catch((err) => err?.response?.data),
};
